/* jinja.js — tiny templater (if/endif + {{ }}) */
(function (global) {
  "use strict";
  function compile(template) {
    return {
      render: function (context) {
        var out = template.replace(
          /\{%-?\s*if\s+([^%]+?)\s*-?%\}([\s\S]*?)\{%-?\s*endif\s*-?%\}/g,
          function (_, condition, inner) {
            try {
              if (Function('"use strict";return (' + condition + ")").call(context)) {
                return compile(inner).render(context);
              }
            } catch (e) {}
            return "";
          }
        );
        out = out.replace(/\{\{\s*(.*?)\s*\}\}/g, function (_, code) {
          try {
            return Function('"use strict";with(this){return (' + code + ')}').call(context);
          } catch (e) { return ""; }
        });
        return out;
      },
    };
  }
  global.jinja = { compile: compile };
})(window);
